
import Select from "react-select";
export const ClienteInfo = ({ empresasOpciones, clientesOpciones, empresaSeleccionada, clienteSeleccionado, formulario, preloadCliente, ejecutarFuncionAdicional, seleccionarCliente, setFormulario }) => {
    return (
        <div className="border rounded p-4 shadow-sm bg-light">
            <h4 className="mb-3 text-dark font-weight-bold">Información del Cliente</h4>
            <div className="mb-3">
                <h5 className="mb-1 text-grey">Seleccione una empresa:</h5>
                <Select
                    options={[{ value: "", label: "Seleccione la empresa" }, ...empresasOpciones, { value: "200", label: "Todas las empresas" }]}
                    value={
                        empresasOpciones.find((e) => e.value === empresaSeleccionada) || {
                            value: "",
                            label: "Seleccione la empresa",
                        }
                    }
                    onChange={(option) => {
                        const nuevoValor = option?.value || "";
                        setFormulario((prev) => ({
                            ...prev,
                            empresaSeleccionada: nuevoValor,
                        }));
                        ejecutarFuncionAdicional(nuevoValor);
                    }}
                />
            </div>
            <hr />
            <div className="mb-3">
                <h5 className="mb-1 text-grey">Seleccione un cliente:</h5>
                {preloadCliente ? (
                    <div className="spinner-border text-dark" role="status">
                        <span className="visually-hidden">Cargando...</span>
                    </div>
                ) : (
                    <Select
                        options={[{ value: "", label: "Seleccione el cliente" }, ...clientesOpciones]}
                        value={
                            clientesOpciones.find((c) => c.value === clienteSeleccionado) || {
                                value: "",
                                label: "Seleccione el cliente",
                            }
                        }
                        onChange={(option) => {
                            const nuevoValor = option?.value || "";
                            setFormulario((prev) => ({
                                ...prev,
                                clienteSeleccionado: nuevoValor,
                            }));
                            seleccionarCliente(nuevoValor);
                        }}
                        isDisabled={!empresaSeleccionada}
                    />
                )}
            </div>
            <hr />
            <div className="mb-3">
                <h5 className="mb-1 text-grey">Correo electrónico</h5>
                <p className="mb-0">{formulario.datosCliente.correo_cleinte || "--"}</p>
            </div>
            <hr />
            <div className="mb-3">
                <h5 className="mb-1 text-grey">Teléfono cliente</h5>
                <p className="mb-0">{formulario.datosCliente.telefono_cliente || "--"}</p>
            </div>
            <br />
            <br />
        </div>
    );
};
